// A file's shape on a grid card, known before its picture loads: the masonry places each card at
// the height it gives, and the card keeps it while its picture arrives (issue 794).
import type { CSSProperties } from "react";

import type { Asset } from "../../api/generated/model";

/** A card's width over its height: the file's own shape, a square where it is not known. */
export function shapeRatio(asset: Asset): number {
  return asset.width !== null && asset.height !== null && asset.width > 0 && asset.height > 0
    ? asset.width / asset.height
    : 1;
}

/** The card's box at the file's shape. */
export function shapeStyle(asset: Asset): CSSProperties {
  const known = asset.width !== null && asset.height !== null && asset.height > 0;
  return { aspectRatio: known ? `${asset.width} / ${asset.height}` : "1" };
}
